import React from 'react';
import { Facebook, Youtube, Instagram, Phone, Mail, MapPin } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-slate-50 pt-20 pb-8 border-t-4 border-accent" data-id="element-41">
      <div className="container mx-auto px-4" data-id="element-42">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16 text-center md:text-left" data-id="element-43">
          <div className="flex flex-col items-center md:items-start" data-id="element-44">
            <div className="mb-6" data-id="element-45">
              <Logo data-id="element-46" />
            </div>
            <p className="font-display text-xl text-slate-900 uppercase tracking-wide mb-2" data-id="element-47">
              Cockrell Custom Repairs
            </p>
            <p className="text-slate-600 text-sm mb-6 max-w-xs" data-id="element-48">
              Expert plumbing and home repair services in Blanchard, OK.
            </p>
            <div className="flex items-center gap-4" data-id="element-49">
              <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-accent hover:bg-accent hover:text-white transition-colors" data-id="element-50">
                <Facebook className="h-5 w-5" data-id="element-51" />
              </a>
              <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-accent hover:bg-accent hover:text-white transition-colors" data-id="element-52">
                <Instagram className="h-5 w-5" data-id="element-53" />
              </a>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-start" data-id="element-54">
            <h4 className="text-lg font-bold text-slate-900 mb-6 uppercase tracking-wider" data-id="element-55">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-56">
              <li data-id="element-57">
                <a href="#services" className="text-slate-600 hover:text-accent transition-colors" data-id="element-58">
                  Services
                </a>
              </li>
              <li data-id="element-59">
                <a href="#gallery" className="text-slate-600 hover:text-accent transition-colors" data-id="element-60">
                  Recent Projects
                </a>
              </li>
              <li data-id="element-61">
                <a href="#reviews" className="text-slate-600 hover:text-accent transition-colors" data-id="element-62">
                  Customer Reviews
                </a>
              </li>
              <li data-id="element-63">
                <a href="#service-area" className="text-slate-600 hover:text-accent transition-colors" data-id="element-64">
                  Service Area
                </a>
              </li>
              <li data-id="element-65">
                <a href="#contact" className="text-slate-600 hover:text-accent transition-colors" data-id="element-66">
                  Book Online
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center md:items-start" data-id="element-67">
            <h4 className="text-lg font-bold text-slate-900 mb-6 uppercase tracking-wider" data-id="element-68">
              Our Services
            </h4>
            <ul className="space-y-4" data-id="element-69">
              <li className="text-slate-600" data-id="element-70">Home Improvements</li>
              <li className="text-slate-600" data-id="element-71">Plumbing Services</li>
              <li className="text-slate-600" data-id="element-72">Well Pump Services</li>
              <li className="text-slate-600" data-id="element-73">Carpentry</li>
              <li className="text-slate-600" data-id="element-74">General Repairs</li>
            </ul>
          </div>

          <div className="flex flex-col items-center md:items-start" data-id="element-75">
            <h4 className="text-lg font-bold text-slate-900 mb-6 uppercase tracking-wider" data-id="element-76">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-77">
              <li data-id="element-78">
                <a href="tel:254-266-9800" className="flex items-center gap-3 text-slate-600 hover:text-accent transition-colors" data-id="element-79">
                  <Phone className="h-5 w-5 text-accent" data-id="element-80" />
                  (254) 266-9800
                </a>
              </li>
              <li data-id="element-81">
                <a href="mailto:cockrell.custom.repairs@gmail.com" className="flex items-center gap-3 text-slate-600 hover:text-accent transition-colors" data-id="element-82">
                  <Mail className="h-5 w-5 text-accent" data-id="element-83" />
                  cockrell.custom.repairs@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-600" data-id="element-84">
                <MapPin className="h-5 w-5 text-accent shrink-0 mt-1" data-id="element-85" />
                <span className="text-left" data-id="element-86">
                  3294 Rolling Hill Dr
                  <br data-id="element-87" />
                  Blanchard, OK 73010
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-500" data-id="element-88">
          <p data-id="element-89">
            &copy; {new Date().getFullYear()} Cockrell Custom Repairs. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}